<script>
import {Message} from "element-ui";
import {allResource, bindResource, deleteRoleById, getRoleResource, roleList, saveOrUpdateRole} from "@/api/user";
import Permission from "@/views/account/Permission.vue";
import AgentTemplate from "@/components/AgentTemplate.vue";

export default {
  name: 'Role',
  components: {AgentTemplate, Permission},
  data() {
    return {
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      roleList: [],
      visible: false,
      role: {},
      submitLoading: false,
      searchKeyword: '',
      rules: {
        name: [
          {required: true, message: '请输入类别名称', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入类别编码', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ]
      },
      selectedRoleId: null,
      activeTab: 'RESOURCE',
      resources: [],
      // 角色关联的资源
      roleRefs : [],
      permissions: [],
      // 客户端类型
      clientType : 'PLATFORM',
    }
  },
  mounted() {
    this.fetchRoleList();
    this.fetchAllResources();
  },
  watch: {
    selectedRoleId: {
      handler(newValue, oldValue) {
        if (!newValue) return
        if (newValue !== oldValue) {
          this.fetchTabData();
        }
      },
      immediate: false,
      deep: false
    }
  },
  methods: {
    async fetchTabData() {
      if (this.activeTab === 'RESOURCE') {
        if (this.resources.length === 0) {
          await this.fetchAllResources()
        }
        // 根据角色ID查询关联的资源ID
        await this.fetchRoleResources();

      } else if (this.activeTab === 'PERMISSION') {

      }
    },

    // 根据角色ID查询关联的资源ID
    async fetchRoleResources() {
      if (!this.selectedRoleId) return;
      try {
        const res = await getRoleResource(this.selectedRoleId);
        if (res && res.code === "0000") {
          // 获取角色关联的资源ID列表
          const resourceIds = res.result || [];
          this.roleRefs = resourceIds;

          // 设置el-tree的选中状态
          this.$nextTick(() => {
            if (this.$refs.tree) {
              this.$refs.tree.setCheckedKeys([]);
              if (resourceIds.length > 0){
                resourceIds.forEach(resourceId => {
                  this.$refs.tree.setChecked(resourceId,true)
                })
              }
            }
          });
        }
      } catch (e) {
        console.error('获取角色资源失败:', e);
        this.roleRefs = [];
      }
    },

    // 保存角色资源关联
    async saveRoleResources() {
      if (!this.selectedRoleId) {
        Message.warning('请先选择角色');
        return;
      }

      // 获取所有选中的节点ID
      const checkedKeys = this.$refs.tree.getCheckedKeys();
      const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
      // 合并选中和半选中的节点ID
      const allSelectedIds = [...checkedKeys, ...halfCheckedKeys];


      try {
        // 调用接口保存角色资源关联
        const res = await bindResource({
          roleId: this.selectedRoleId,
          resourceIds: allSelectedIds
        });
        if (res && res.code === "0000") {
          Message.success('资源绑定成功');
        }
      } catch (e) {
        console.error('绑定资源失败:', e);
        Message.error('绑定资源失败');
      }
    },

    async fetchAllResources() {
      try {
        const res = await allResource(this.clientType);
        if (res && res.code === "0000") {
          this.resources = res.result || [];
        }
      } catch (e) {
        console.log(e)
        this.resources = [];
      }
    },

    openEditDrawer() {
      if (this.role.id) {
        this.role = {}
      }
      this.visible = !this.visible;
    },

    async fetchRoleList() {
      try {
        const params = {
          current: 1,
          size: 100,
          filter: [
              {
                name: 'clientType',
                type: 'EQ',
                value: this.clientType
              }
          ],
          sorted: [{
            name: 'createdTime',
            type: 'DESC'
          }]
        }
        // 模拟数据
        const res = await roleList(params);
        if (res && res.code === "0000") {
          this.roleList = res.result.records;
        }
      } catch (e) {
        console.log(e)
        this.roleList = []; // 确保有默认空数组
      }
    },
    async submitRole() {
      this.$refs.roleFormRef.validate(async valid => {
        if (valid){
          this.submitLoading = true;
          try {
            if (!this.role.id) {
              // 新增
              const res = await saveOrUpdateRole(this.role);
              if (res && res.code === "0000") {
                Message.success('新增角色成功');
              }
            } else {
              // 编辑
              const res = await saveOrUpdateRole(this.role);
              if (res && res.code === "0000") {
                Message.success('更新角色成功');
              }
            }
          } catch (e) {
            Message.error('操作失败');
          } finally {
            this.submitLoading = false;
          }

          this.cleanRole();
          this.fetchRoleList();
          this.$refs.editDrawer.closeDrawer()
        }
      })


    },

    async deleteRole(id) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          deleteRoleById(id).then( res => {
            if (res && res.code === "0000") {
              Message.success(`删除成功`);
              this.cleanRole();
              this.fetchRoleList();
            }
          })
        } catch (e) {
          Message.error('删除失败');
        }
      }).catch(() => {

      });

    },
    selectRole(role) {
      this.selectedRoleId = role.id;
    },

    handleEdit(item) {
      this.role = {
        ...item
      }
      this.visible = true

    },

    cleanRole() {
      this.role = {}
      this.currentPage = 1
    },

    handleSearch() {
      this.cleanRole();
      this.fetchRoleList()
    },

    changeClientType(){
      this.fetchAllResources()
      this.fetchRoleList()
    },

    changeBizLine(){
      this.fetchAllResources()
    }

  },
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="never">
          <div slot="header" class="clearfix" style="display: flex; justify-content: space-between; align-items: center">
            <div style="display: flex; align-items: center;gap: 6px">
              <div>角色管理</div>
              <el-select size="small" v-model="clientType" placeholder="请选择客户端类型" class="form-select" @change="changeClientType">
                <el-option label="平台后台" value="PLATFORM"/>
                <el-option label="安全环境管理后台" value="SEM"/>
              </el-select>
            </div>
            <el-button style="float: right; padding: 3px 0" type="text" @click="openEditDrawer">新增</el-button>
          </div>

          <div class="role-list">
            <div
                class="role-item"
                v-for="item in roleList"
                :key="item.id"
                :class="{ 'selected': selectedRoleId === item.id }"
                @click="selectRole(item)"
            >
              <div class="role-title">{{ item.name }} <div class="role-sub-title">({{ item.clientType === 'PLATFORM' ? '平台后台' : '安全环境管理后台'}})</div> </div>
              <el-row :gutter="2" align="center" justify="right">
                <el-button type="text" @click.stop="handleEdit(item)">编辑</el-button>
                <el-button type="text" style="color: red" @click.stop="deleteRole(item.id)">删除</el-button>
              </el-row>
            </div>
          </div>

        </el-card>
      </el-col>

      <el-col :span="16">
        <el-card shadow="never">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="菜单资源" name="RESOURCE">
              <div style="margin-bottom: 20px;display: flex; justify-content: space-between;">
                <div style="content: ''"></div>
                <el-button type="primary" size="small" @click="saveRoleResources">保存资源</el-button>
              </div>
              <el-tree
                  :data="resources"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="{
                    children: 'child',
                    label: 'name'
                  }"
              >
                <div style="display: flex;justify-content: center;align-items: center;width: 100%; padding: 4px 0; font-size: 14px"
                     slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span class="divider" />
                  <span :class="['resource-type', data.type === '1' ? 'menu' : 'button']">
                    {{data.type === '1' ? '菜单' : '按钮'}}
                  </span>
                </div>
              </el-tree>
            </el-tab-pane>

            <el-tab-pane label="数据权限" name="PERMISSION">
              <div v-if="selectedRoleId && selectedRoleId === 1">
                <el-empty description="该角色已由系统控制数据权限" />
              </div>
              <div v-else-if="selectedRoleId && selectedRoleId === 2">
                <AgentTemplate :role-id="selectedRoleId" />
              </div>
              <div v-else>
                <Permission ref="permissionRef" :role-id="selectedRoleId"/>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <el-drawer
        :title="role.id ? '编辑角色': '新增角色'"
        :visible.sync="visible"
        direction="rtl"
        ref="editDrawer"
    >
      <div class="edit-container">
        <el-form ref="roleFormRef" :model="role" label-width="100px" :rules="rules" style="width: 100%;">
          <el-form-item label="名称" prop="name" style="width: 100%;">
            <el-input v-model="role.name" clearable style="width: 100%;"/>
          </el-form-item>
          <el-form-item label="编码" prop="code" style="width: 100%;">
            <el-input v-model="role.code" clearable style="width: 100%;"/>
          </el-form-item>
          <el-form-item label="客户端类型">
            <el-select v-model="role.clientType" placeholder="请选择客户端类型" clearable class="form-select">
              <el-option label="平台后台" value="PLATFORM"/>
              <el-option label="安全环境管理后台" value="SEM"/>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" style="width: 100%;">
            <el-input v-model="role.remark" type="textarea" clearable style="width: 100%;"/>
          </el-form-item>
        </el-form>
        <div class="edit-footer">
          <el-button @click="$refs.editDrawer.closeDrawer()">取 消</el-button>
          <el-button type="primary" @click="submitRole" :loading="submitLoading">
            {{ submitLoading ? '提交中 ...' : '提 交' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>

</template>

<style scoped>
.role-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: left;
  height: 60vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 10px;

  .role-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border: 1px solid #dcdfe6; /* 添加边框 */
    border-radius: 18px; /* 添加圆角 */
    padding: 8px 12px; /* 增加内边距使内容更舒适 */
    transition: all 0.3s ease; /* 添加过渡效果让选中状态变化更平滑 */
    box-sizing: border-box;
    .role-title {
      font-size: 13px;
      font-weight: bold;
      margin-left: 12px;
      display: inline-flex;
      align-items: flex-end;

    }
    .role-sub-title {
      font-size: 11px;
      margin-left: 10px;
      display: inline-flex;
    }
  }

  .role-item:hover {
    background-color: #f5f7fa;
    border-color: #c0c4cc; /* 鼠标悬停时边框颜色加深 */
  }

  .role-item.selected {
    background-color: #e6f7ff;
    border-color: #1890ff; /* 选中状态的边框颜色 */
    border-left: 3px solid #1890ff;
    box-shadow: 0 0 0 1px rgba(24, 144, 255, 0.1); /* 添加轻微阴影增强卡片感 */
  }

  .role-item.selected .role-title {
    color: #1890ff;
    font-weight: 500;
  }


}

.edit-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  flex: 1;
  position: relative;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .edit-footer {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
  }
}

.resource-type {
  border: 1px dashed;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 10px;
}

.resource-type.menu {
  border-color: #409EFF;
  color: #409EFF;
}

.resource-type.button {
  border-color: #909399;
  color: #909399;
}

.divider {
  flex: 1;
  height: 1px;
  border-top: 1px dashed #dcdfe6;
  margin: 0 8px;
}

</style>
